/**
 * SPLH Dashboard Constants
 *
 * Constant values used throughout the SPLH Performance Dashboard.
 *
 * @module pages/common/dashboards/SPLHDashboard/constants
 */

/**
 * Default client ID for initial implementation
 * @constant {string}
 */
export const DEFAULT_CLIENT_ID = 'dem50';

/**
 * Default date range preset
 * @constant {string}
 */
export const DEFAULT_DATE_RANGE_PRESET = 'last7days';

/**
 * Cache TTL for dashboard data (in milliseconds)
 * @constant {number}
 */
export const CACHE_TTL = 5 * 60 * 1000; // 5 minutes

/**
 * Debounce delay for filter changes (in milliseconds)
 * @constant {number}
 */
export const FILTER_DEBOUNCE_DELAY = 300;

/**
 * Maximum number of alerts to display
 * @constant {number}
 */
export const MAX_ALERTS_DISPLAY = 5;

/**
 * OrgLevel enum values (matching GraphQL schema)
 * @constant {Object}
 */
export const ORG_LEVELS = {
  ORGLEVEL_1: 'ORGLEVEL_1',
  ORGLEVEL_2: 'ORGLEVEL_2',
  ORGLEVEL_3: 'ORGLEVEL_3',
  LOCATION_LEVEL: 'LOCATION_LEVEL',
};

/**
 * Trend direction enum values
 * @constant {Object}
 */
export const TREND_DIRECTIONS = {
  UP: 'up',
  DOWN: 'down',
  FLAT: 'flat',
};

/**
 * Alert severity enum values
 * @constant {Object}
 */
export const ALERT_SEVERITY = {
  INFO: 'info',
  WARNING: 'warning',
  CRITICAL: 'critical',
};
